<template>
  <section class="quote">
    <div class="container">
      <p class="quote-line">
        <span class="quote-text">"{{ $t('homePage.quoteWD') }}"</span>
        <span class="quote-author">- Walt Disney</span>
      </p>
    </div>
  </section>
</template>

<style scoped>
section.quote {
  min-height: 0;
  background: var(--color-bg-dark);
  color: var(--color-light);
  display: flex;
  align-items: center;
}

.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 40px 24px;
}

.quote-line {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 0;
  align-items: baseline;
}

.quote-text {
  min-width: 0;
}

.quote-author {
  white-space: nowrap;
}

@media (aspect-ratio <= 3/4) {
  .container {
    max-width: none;
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
  }

  .quote-line {
    width: 100%;
  }
}
</style>
